import { render, staticRenderFns } from "./TalentRecruitment.vue?vue&type=template&id=35a0ff92&scoped=true&"
import script from "./TalentRecruitment.vue?vue&type=script&lang=js&"
export * from "./TalentRecruitment.vue?vue&type=script&lang=js&"
import style0 from "./TalentRecruitment.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TalentRecruitment.vue?vue&type=style&index=1&id=35a0ff92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a0ff92",
  null
  
)

export default component.exports